'use client';

import Script from 'next/script';
import { useEffect, useRef, useState } from 'react';

declare global {
  interface Window {
    CLUTCHCO?: Record<string, unknown>;
  }
}

const ClutchWidget = () => {
  const widgetRef = useRef<HTMLDivElement>(null);
  const [key, setKey] = useState(0);

  const initClutch = () => {
    setKey((k) => k + 1);

    setTimeout(() => {
      if (!window.CLUTCHCO) return;
      const fn = Object.values(window.CLUTCHCO).find(
        (v) => typeof v === 'function',
      ) as (() => void) | undefined;
      fn?.();
    }, 100);
  };

  useEffect(() => {
    // Handles return navigation — script already loaded, onLoad won't fire
    if (window.CLUTCHCO) {
      initClutch();
    }
  }, []);

  return (
    <div style={{ minHeight: '55px' }}>
      <Script
        id="clutch-js"
        src="https://widget.clutch.co/static/js/widget.js"
        strategy="afterInteractive"
        onLoad={initClutch} // ← first visit
      />

      <div
        key={key}
        ref={widgetRef}
        className="clutch-widget rounded-lg bg-white p-4"
        data-url="https://widget.clutch.co"
        data-widget-type="2"
        data-height="50"
        data-nofollow="false"
        data-expandifr="true"
        data-scale="100"
        data-clutchcompany-id="2428594"
      />
    </div>
  );
};

export default ClutchWidget;
